import {
	FETCH_SPINS_REQUEST,
	FETCH_SPINS_SUCCESS,
	FETCH_SPINS_FAIL,
	FETCH_SPIN_REQUEST,
	FETCH_SPIN_SUCCESS,
	FETCH_SPIN_FAIL,
	DOWNLOAD_SPINS_REQUEST,
	DOWNLOAD_SPINS_SUCCESS,
	DOWNLOAD_SPINS_FAIL,
} from "../constants/spinTheWheelOverview";

function fetchSpinsReducer(state, action) {
	if (typeof state === "undefined") {
		state = {
			status: "IDLE",
			error: null,
		};
	}
	switch (action.type) {
		case FETCH_SPINS_REQUEST:
			return { loading: true, status: "IDLE" };
		case FETCH_SPINS_SUCCESS:
			return {
				...state,
				loading: false,
				status: "SUCCEEDED",
				spins: action.payload,
			};
		case FETCH_SPINS_FAIL:
			return { loading: false, status: "FAILED", error: action.payload };
		default:
			return state;
	}
}

function fetchSpinReducer(state, action) {
	if (typeof state === "undefined") {
		state = {
			status: "IDLE",
			error: null,
		};
	}

	switch (action.type) {
		case FETCH_SPIN_REQUEST:
			return { loading: true, status: "IDLE" };
		case FETCH_SPIN_SUCCESS:
			return {
				...state,
				loading: false,
				status: "SUCCEEDED",
				spin: action.payload,
			};
		case FETCH_SPIN_FAIL:
			return { loading: false, status: "FAILED", error: action.payload };
		default:
			return state;
	}
}

function exportSpinReducer(state, action) {
	if (typeof state === "undefined") {
		state = {
			status: "IDLE",
			error: null,
		};
	}
	switch (action.type) {
		case DOWNLOAD_SPINS_REQUEST:
			return { loading: true, status: "IDLE" };
		case DOWNLOAD_SPINS_SUCCESS:
			return {
				...state,
				loading: false,
				status: "SUCCEEDED",
				file: action.payload,
			};
		case DOWNLOAD_SPINS_FAIL:
			return { loading: false, status: "FAILED", error: action.payload };
		default:
			return state;
	}
}

export { fetchSpinsReducer, fetchSpinReducer, exportSpinReducer };
